import React from "react";
import { Col } from "react-bootstrap";

const boxStyles = {
  maxHeight: "60px",
  color: "#fff",
};

const titleStyles = {
  fontSize: ".5em",
  textDecoration: "none",
  textTransform: "uppercase",
};

export default function SalesBox(props) {
  const { styleName, title, icons, toggleState } = props;
  return (
    <>
      <Col lg={3} md={4} sm={6} xs={12}>
        <Col
          className="d-flex justify-content-start align-items-center rounded p-3"
          id={styleName}
          style={boxStyles}
          onClick={toggleState}>
          <h2>
            <span style={titleStyles}>{title}</span>
          </h2>
          <>{icons}</>
        </Col>
      </Col>
    </>
  );
}
